__turbopack_context__.v({
  "appear-slide-left": "ServicePosts-module-scss-module__-qYvaa__appear-slide-left",
  "bounceTwice": "ServicePosts-module-scss-module__-qYvaa__bounceTwice",
  "container": "ServicePosts-module-scss-module__-qYvaa__container",
  "fade-in-bottom": "ServicePosts-module-scss-module__-qYvaa__fade-in-bottom",
  "fade-in-left": "ServicePosts-module-scss-module__-qYvaa__fade-in-left",
  "fade-in-right": "ServicePosts-module-scss-module__-qYvaa__fade-in-right",
  "fadeIn": "ServicePosts-module-scss-module__-qYvaa__fadeIn",
  "heading": "ServicePosts-module-scss-module__-qYvaa__heading",
  "icon": "ServicePosts-module-scss-module__-qYvaa__icon",
  "imaged": "ServicePosts-module-scss-module__-qYvaa__imaged",
  "loader": "ServicePosts-module-scss-module__-qYvaa__loader",
  "motionImgContainer": "ServicePosts-module-scss-module__-qYvaa__motionImgContainer",
  "post": "ServicePosts-module-scss-module__-qYvaa__post",
  "postImage": "ServicePosts-module-scss-module__-qYvaa__postImage",
  "posts": "ServicePosts-module-scss-module__-qYvaa__posts",
  "postsContainer": "ServicePosts-module-scss-module__-qYvaa__postsContainer",
  "puff-in-center": "ServicePosts-module-scss-module__-qYvaa__puff-in-center",
  "puff-in-left": "ServicePosts-module-scss-module__-qYvaa__puff-in-left",
  "pulse": "ServicePosts-module-scss-module__-qYvaa__pulse",
  "pulse-contact": "ServicePosts-module-scss-module__-qYvaa__pulse-contact",
  "shake-bottom": "ServicePosts-module-scss-module__-qYvaa__shake-bottom",
  "slide-again": "ServicePosts-module-scss-module__-qYvaa__slide-again",
  "slide-in-right": "ServicePosts-module-scss-module__-qYvaa__slide-in-right",
  "stepContent-entrance": "ServicePosts-module-scss-module__-qYvaa__stepContent-entrance",
  "text": "ServicePosts-module-scss-module__-qYvaa__text",
});
